module.exports = __webpack_public_path__ + "img/bottom_logo.77224132.png";